import { ChartData } from 'chart.js';

export function getMaxDataValue(barChartData: ChartData): number {
  if (!barChartData?.datasets?.length) return 0;

  return (
    Math.max(
      ...barChartData.datasets.flatMap(
        dataset => (dataset?.data?.filter(value => value !== null && value !== undefined) as number[]) || []
      )
    ) || 0
  );
}
